<template>
  <div id="header" class="header">
    <HeaderHome v-if="tln == 'home'" ref="headerHomeM"></HeaderHome>
    <HeaderProject v-if="tln == 'project'" v-slot:pin><slot name="imgname"></slot></HeaderProject>
  </div>
</template>

<script>
  import HeaderHome from "../HeaderHome.vue";
  import HeaderProject from "../HeaderProject.vue";
  export default {
    name: "Header",
    props: ["tln"],
    data: function() {
      return {

      }
    },
    mounted:function(){
      if(this.tln == "home") {
        window.addEventListener('scroll', this.handleScroll, true);
      }
    },
    components: { HeaderHome, HeaderProject },
    methods: {
      // 保存滚动值，这是兼容的写法
      handleScroll: function(e) {
        var headerHeight = (document.querySelector("#header").offsetHeight) * 0.96463;
        var dom = e.target;
        this.scrollTop = dom.pageYOffset || dom.scrollTop;
        (this.scrollTop > ((headerHeight > 0)?headerHeight:943))?this.$refs.headerHomeM.menuStyle(true):this.$refs.headerHomeM.menuStyle(false);
      }
    }
  }
</script>

<style lang="less">
  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 9999;
    .header_content {
      width: 100%;
      position: relative;
      z-index: 2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue